import { FC, useEffect, useMemo } from 'react'
import { Box } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { CustomFeedback, DynamicInputByType, FormItem } from 'components'
import { focusElementById } from 'utils/events'

type Props = {
  autoFocus?: boolean
  metadataIndexes?: number[]
  metadataPrefix: string
  entity: any
  register: UseFormRegister<any>
}

const MetadatasForm: FC<Props> = ({
  autoFocus = false,
  metadataIndexes = [1, 2, 3, 4, 5, 6, 7],
  entity,
  metadataPrefix,
  register,
}) => {
  const metadatasWithInfos: number[] = useMemo(() => {
    return metadataIndexes.filter((index) => {
      const label = entity[`${metadataPrefix}_${index}_label`]
      return label !== null
    })
  }, [entity, metadataPrefix])

  useEffect(() => {
    if (autoFocus && metadatasWithInfos.length > 0) focusElementById(metadataIndexes[0].toString())
  }, [metadatasWithInfos])

  if (metadatasWithInfos.length === 0) {
    return <CustomFeedback context="withoutMetadatas" />
  }

  return (
    <Box>
      {metadatasWithInfos.map((index) => {
        const label = entity[`${metadataPrefix}_${index}_label`]
        const type = entity[`${metadataPrefix}_${index}_data_type`]
        if (!label) return null
        return (
          <FormItem key={index} label={label as string}>
            <DynamicInputByType id={index.toString()} type={type} {...register(`info_${index}`)} />
          </FormItem>
        )
      })}
    </Box>
  )
}

export default MetadatasForm
